// Coordinates.js
import { map } from './Map';
import { CoordinateService } from './CoordinateService'; // استيراد الخدمة المركزية

// إضافة كلاسات مخصصة (coord-value) لضمان عدم انهيار العرض عند تغيير الهيكلية
// 1. New Compact HTML Structure with Badge
const coordinatesDisplay = $(`
    <div id="coordinates-display" class="hide-coords">
        <div id="coord-data">
            <div id="coord-local" class="coord-row">
                <span class="coord-value">---, ---</span>
            </div>
            <div id="coord-wgs84" class="coord-row" style="display:none;">
                <span class="coord-value">---, ---</span>
            </div>
        </div>
        <button id="coord-toggle-btn" title="تبديل النظام">
            <i class="fa-solid fa-globe"></i>
            <span id="coord-sys-badge">PS</span>
        </button>
    </div>
`);
$('body').append(coordinatesDisplay);

// 2. Toggle Visibility (Slide from under footer)
const toggleButton = $('#toggleCoords');
toggleButton.on('click', () => {
    const isHidden = $('#coordinates-display').toggleClass('hide-coords').hasClass('hide-coords');
    toggleButton.toggleClass('active', !isHidden);
});

// 3. System Switch Logic (Update Badge & Value)
let coordsMode = 'local';
function applyCoordsMode() {
    if (coordsMode === 'local') {
        $('#coord-local').show();
        $('#coord-wgs84').hide();
        $('#coord-sys-badge').text('PS').css('background', 'var(--primary)');
    } else {
        $('#coord-local').hide();
        $('#coord-wgs84').show();
        $('#coord-sys-badge').text('W').css('background', 'var(--info)');
    }
}

$('#coord-toggle-btn').on('click', (e) => {
    e.preventDefault();
    coordsMode = (coordsMode === 'local') ? 'wgs' : 'local';
    applyCoordsMode();
    // Spin animation
    $('#coord-toggle-btn i').addClass('fa-spin');
    setTimeout(() => $('#coord-toggle-btn i').removeClass('fa-spin'), 300);
});

applyCoordsMode();



let animationFrameId = null;

function setDisplayFromCoordinate(coordinate) {
    if (!coordinate) return;
    const mapProjCode = map.getView().getProjection().getCode();

    // التحديث باستخدام الكلاس الآمن بدلاً من last-child
    $('#coord-local .coord-value').text(CoordinateService.formatLocal(coordinate[0], coordinate[1]));

    const wgs84 = CoordinateService.toWGS84(coordinate, mapProjCode);
    if (wgs84) {
        const lon = wgs84[0].toFixed(6);
        const lat = wgs84[1].toFixed(6);
        $('#coord-wgs84 .coord-value').text(`${lon}, ${lat}`);
    } else {
        $('#coord-wgs84 .coord-value').text('---, ---');
    }
}

// ✅ Desktop فقط — ماوس بدون سحب
map.on('pointermove', function (evt) {
    if (evt.dragging || !evt.coordinate) return;
    if ($('#coordinates-display').hasClass('hide-coords')) return;

    if (animationFrameId) cancelAnimationFrame(animationFrameId);
    animationFrameId = requestAnimationFrame(() => {
        setDisplayFromCoordinate(evt.coordinate);
    });
});

// ✅ هاتف + Desktop أثناء السحب — مباشر بدون rAF
map.on('pointerdrag', function (evt) {
    if (!evt.coordinate) return;
    if ($('#coordinates-display').hasClass('hide-coords')) return;
    setDisplayFromCoordinate(evt.coordinate);
});

// ✅ نقر فوري (بدون تأخير 250ms)
map.on('pointerdown', function (evt) {
    if (!evt.coordinate) return;
    setDisplayFromCoordinate(evt.coordinate);
});

// ✅ مسح عند مغادرة الخريطة
map.getViewport().addEventListener('mouseleave', function () {
    $('#coord-local .coord-value').text('---, ---');
    $('#coord-wgs84 .coord-value').text('---, ---');
});
